import { appEventsAtom, exchangeDataAtom } from '@/state/app';
import { walletAtom } from '@/state/wallet';
import { useEffect } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useExchangeContracts } from '@/hooks/exchange/contracts';

/*
 * This hook is used to refresh contract level data
 */

export const useClayExchangeData = () => {
    const { getSplitFee } = useExchangeContracts();
    const walletState = useRecoilValue(walletAtom);
    const [exchangeData, setExchangeData] = useRecoilState(exchangeDataAtom);

    useEffect(() => {
        loadData().then();
    }, [walletState.selectedAddress, walletState.chainId]);

    const loadData = async () => {
        if (walletState.chainId) {
            const [splitFee] = await Promise.all([getSplitFee()]);
            setExchangeData((previous) => ({
                ...previous,
                splitFee,
                update: new Date().getTime(),
            }));
        }
    };
};
